import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-av-pg-back',
  templateUrl: './av-pg-back.component.html',
  styleUrls: ['./av-pg-back.component.scss']
})
export class AvPgBackComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
